module.exports = __webpack_public_path__ + "static/media/starfilled.18b01442.svg";